import utils from '@src/common/utils'
import { Dic } from '$utils'
const tableOption = function (that) {
  return {
    add: '新增',
    edit: '修改',
    view: '查看',
    page: true,
    selection: true,
    index: true,
    indexLabel: '序号',
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    align: 'left',
    size: 'small',
    maxHeight: '100%',
    labelWidth: '100px',
    menuAlign: 'center',
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 400,
    dialogWidth: '700px',
    emptyText: '暂无数据',
    column: [
      {
        label: '任务名称',
        prop: 'taskName',
        search: true,
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        span: 24,
        align: 'center'
      },
      {
        label: '启用状态',
        prop: 'status',
        search: true,
        type: 'select',
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        // formslot: true,
        span: 12,
        viewFormatter: (row, value) => {
          if (Number(value) === 1) {
            return '启用'
          } else if (Number(value) === 2) {
            return '禁用'
          }
          return '';
        },
        dicData: [
          {
            label: '启用',
            value: '1'
          },
          {
            label: '禁用',
            value: '2'
          }
        ],
        align: 'center'
      },
      {
        label: '测速摄像机',
        prop: 'cameras',
        addDisplay: false,
        editDisplay: false,
        overHidden: true,
        align: 'center',
        span: 12
      },
      {
        label: '限速(km/h)',
        prop: 'overSpeed',
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        align: 'center',
        span: 12
      },
      {
        label: '允许上浮速度（km/h）',
        prop: 'floatSpeed',
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        align: 'center',
        span: 12
      },
      {
        label: '任务描述',
        prop: 'desc',
        type: 'select',
        addDisplay: false,
        editDisplay: false,
        overHidden: true,
        align: 'center',
        span: 12
      }
    ]
  }
}
export default tableOption